import React from 'react';
import VIDABOO_CONSTANTS from '../../config/consts';
import {ListeningRoomService} from '../../services/websocketService';
import {AppContext} from '../../AppModule/Context';
import SessionService from '../../services/restServices/sessionTemplateService';
import PaymentRequestInitiatorRender from './PaymentRequestInitiatorRender';

const PAYMENT_STATUS = {
  INIT: 'INIT',
  REQUEST_SENT: 'REQUEST_SENT',
  REQUEST_RECEIVED_ON_PEER: 'REQUEST_RECEIVED_ON_PEER',
  PEER_ACCEPTED_AND_STARTED_PAYMENT_FLOW:
    'PEER_ACCEPTED_AND_STARTED_PAYMENT_FLOW',
  PEER_REJECTED: 'PEER_REJECTED',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
};
export default class PaymentRequestInitiatorComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      paymentStatus: PAYMENT_STATUS.INIT,
      inChatSessionModified: false,
    };
  }
  componentDidMount = () => {
    this.registerListeners();
    this.getSessionTemplateDtos();
    this.setPaymentTransactionCurrencies();
  };
  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom();
  };
  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType ===
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT
        ) {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES
              .PAYMENT_POST_PAYMENT_RESOLUTION
          ) {
            if (
              data.content.status ===
              VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS
            ) {
              this.setState({paymentStatus: PAYMENT_STATUS.SUCCESS});
            } else {
              this.setState({paymentStatus: PAYMENT_STATUS.FAIL});
            }
          } else if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_RECEIVED
          ) {
            this.setState({
              paymentStatus: PAYMENT_STATUS.REQUEST_RECEIVED_ON_PEER,
            });
          } else if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_ACCEPTED
          ) {
            this.setState({
              paymentStatus:
                PAYMENT_STATUS.PEER_ACCEPTED_AND_STARTED_PAYMENT_FLOW,
            });
          } else if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST_REJECTED
          ) {
            this.setState({paymentStatus: PAYMENT_STATUS.PEER_REJECTED});
          }
        }
      });
  };
  getCurrencySymbol = () => {
    const currency = this.state.sessionDto.sessionCurrency;
    return currency === 'USD'
      ? '$'
      : currency === 'EUR'
        ? '€'
        : currency === 'GBP'
          ? '£'
          : '₪';
  };
  handleSubmit = () => {
    if (this.state.inChatSessionModified) {
      SessionService.updateSessionTemplateBySTId(
        this.state.sessionDto.sessionTemplateId,
        this.state.sessionDto,
        (sessionDto) => {
          this.setState({sessionDto});
          this.sendPaymentRequestToPeer();
        },
        () => {
          console.debug('failure');
        },
      );
    } else {
      this.sendPaymentRequestToPeer();
    }
    this.setState({paymentStatus: PAYMENT_STATUS.REQUEST_SENT});
  };
  sendPaymentRequestToPeer = () => {
    const messageToSend = this.createChatMessageData('Payment request');
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.context.currentUser.userId,
      this.props.peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.DIRECT_PAYMENT,
    );
  };
  createChatMessageData = (messageContent, subtype) => {
    const tag = new Date().getTime() + '_' + Math.floor(Math.random() * 1e14);
    return {
      SubType: subtype
        ? subtype
        : VIDABOO_CONSTANTS.DIRECT_PAYMENT_SUBTYPES.PAYMENT_REQUEST,
      // senderProfileName: this.context.currentUser.profileName,
      sessionTemplateDto: this.state.sessionDto,
      senderUserId: this.context.currentUser.userId,
      message: messageContent,
      senderCreationTime: new Date().getTime(),
      targetChatRoomId: this.props.chatRoomDto.chatRoomId,
      messageTag:
        this.props.chatRoomDto.chatRoomId +
        '_' +
        this.context.currentUser.userId +
        '_' +
        tag,
    };
  };
  doWhenSessionsReceived = (sessionsData) => {
    const inChatSessions = sessionsData.filter((session) => {
      return (
        session.paymentFlow ===
        VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE.DURING_CHAT
      );
    });
    if (inChatSessions.length > 0) {
      this.setState({
        sessionDto: inChatSessions[0],
      });
    } else {
      const inChatSessionTemplate = {
        sessionTitle: 'In-Chat Money Transfer',
        paymentFlow:
          VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE.DURING_CHAT,
        sessionCurrency: 'USD',
        sessionCost: 1,
        sessionMode: 'AUDIO_VIDEO',
        sessionType: 'TIME_LIMIT',
        activationStatus: 'ACTIVE',
        isDefault: false,
      };
      SessionService.createSessionTemplate(
        this.props.chatRoomDto.ownerObjectId,
        inChatSessionTemplate,
        this.getSessionTemplateDtos,
        () => {},
      );
    }
  };

  getSessionTemplateDtos = () => {
    SessionService.getSessionTemplatesByMentorId(
      this.props.chatRoomDto.ownerObjectId,
      this.doWhenSessionsReceived,
      () => {
        console.debug('failure');
      },
    );
  };
  handleCurrencyChange = (value) => {
    let sessionDto = {...this.state.sessionDto};
    sessionDto.sessionCurrency = value;
    this.setState({
      sessionDto,
      inChatSessionModified: true,
    });
  };

  handlePaymentCost = (event) => {
    let sessionDto = this.state.sessionDto;
    if (event.target.id === 'paymentCost') {
      if (
        event.target.value >= VIDABOO_CONSTANTS.PAYMENT_AMOUNT.MIN_VALUE &&
        event.target.value <= VIDABOO_CONSTANTS.PAYMENT_AMOUNT.MAX_VALUE
      ) {
        sessionDto.sessionCost = event.target.value;
        this.setState({
          sessionDto,
          inChatSessionModified: true,
          paymentError: false,
        });
      } else {
        this.setState({
          paymentError: true,
        });
      }
    }
  };

  setPaymentTransactionCurrencies = () => {
    let paymentTransactionCurrencies = [];
    for (const paymentTransactionCurrency of Object.keys(
      VIDABOO_CONSTANTS.PAYMENT_TRANSACTION_CURRENCIES,
    )) {
      paymentTransactionCurrencies.push({
        key: paymentTransactionCurrency,
        value: paymentTransactionCurrency,
      });
    }
    this.setState({paymentTransactionCurrencies});
  };
  setIsFetchingConfiguration = (isFetchingConfiguration) => {
    this.setState({isFetchingConfiguration});
  };
  render() {
    return (
      <PaymentRequestInitiatorRender
        parentRef={this}
        PAYMENT_STATUS={PAYMENT_STATUS}
      />
    );
  }
}
PaymentRequestInitiatorComponent.contextType = AppContext;
